export enum EManufacturedSmartDeviceType {
  SMART_PLUG = "SMART_PLUG",
  AC_CONTROLLER = "AC_CONTROLLER",
  MODBUS_READER = "MODBUS_READER",
  LOAD_MONITOR = "LOAD_MONITOR",
}
